import { useEffect } from 'react';
import { useHasHydrated } from '../useHasHydrated';
import { useAuthStore } from '@/store';

export const useLogoutOnSessionEnd = () => {
    const hasHydrated = useHasHydrated();
    const { isLoggedIn, sessionCheckIsCurrent } = useAuthStore((state) => ({
        isLoggedIn: state.loggedIn,
        sessionCheckIsCurrent: state.sessionCheckIsCurrent(),
    }));
    const expiredUserLogin = isLoggedIn && !sessionCheckIsCurrent;
    useEffect(() => {
        if (hasHydrated && expiredUserLogin) {
            useAuthStore.setState((state) => ({
                ...state,
                loggedIn: false,
            }));
        }
    }, [hasHydrated, expiredUserLogin]);
};
